import type { IconData } from '@stacksjs/iconify-core'

export const textFormattingBehindImage: IconData = {
  "body": "<path fill=\"currentColor\" d=\"M0 0h16v2.5H0zm0 4.5V7h4.5v2H0v2.5h16V9h-4.5V7H16V4.5zm16 9H0V16h16z\"/>",
  "width": 24,
  "height": 24,
  "viewBox": "0 0 24 24"
}

export default textFormattingBehindImage
